const evtType = {
  LandMark: "LandMark",
  LandRights: "LandRights",
};

export default evtType;
